import React from 'react';
import Product from "../components/Product";
import {ProfilesIcon2, ProfilesIcon5} from "../assets/imageAssets";

const TOPICS = [
    {
        id: 1,
        title: 'Physical Health Score',
        description: 'Rate your overall physical health and compare it with national health and fitness averages.',
    },
    {
        id: 2,
        title: 'Mental Well-being',
        description: 'Assess your emotional resilience and see how it compares with broader mental health trends.',
    },
    {
        id: 3,
        title: 'Social Connectedness',
        description: 'Evaluate your social support and compare it with connection levels across different groups.',
    },
    {
        id: 4,
        title: 'Daily Wellness Habits',
        description: 'Reflect on your health habits and compare them to wellness patterns in broader populations.',
    },
    {
        id: 5,
        title: 'Access to Health Resources',
        description: 'Share your healthcare access and compare it with coverage and accessibility rates across regions.',
    },
];

const HealthWellBeing = () => {
    return (
        <Product
            title={'Health & Well-being'}
            description={'See how people balance their physical, emotional, and social health — and what supports their happiness.'}
            icon={ProfilesIcon5}
            pageColor={'green'}
            topicsList={TOPICS}
        />
    );
}

export default HealthWellBeing;
